import { render, staticRenderFns } from "./NeuroResultCalc.vue?vue&type=template&id=0b97d85f&scoped=true&"
import script from "./NeuroResultCalc.vue?vue&type=script&lang=js&"
export * from "./NeuroResultCalc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b97d85f",
  null
  
)

export default component.exports